import { render, staticRenderFns } from "./TaskPreview.vue?vue&type=template&id=61d3bb73&scoped=true"
import script from "./TaskPreview.vue?vue&type=script&lang=js"
export * from "./TaskPreview.vue?vue&type=script&lang=js"
import style0 from "./TaskPreview.vue?vue&type=style&index=0&id=61d3bb73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d3bb73",
  null
  
)

export default component.exports